import { render, staticRenderFns } from "./ProfileDrugAllergy.vue?vue&type=template&id=2a519cfa&"
import script from "./ProfileDrugAllergy.vue?vue&type=script&lang=js&"
export * from "./ProfileDrugAllergy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports